import React from "react";

export const financeTableHeaderData = (isDarkMode = false) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 140,
    headerName: "Serial number",
    field: "serialNumber",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "serialNumber",
    isDefaultFilterColumn: true,
    fieldKey: "serialNumber",
    formFieldTitle: "Serial number",
    disableColumnMenu: true,
    searchKey: "serialNumber",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.companyFinanceId || "N/A"}
        </label>
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 220,
    headerName: "Finance company",
    field: "financeCompany",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "financeCompany",
    isDefaultFilterColumn: true,
    fieldKey: "financeCompany",
    formFieldTitle: "Finance company",
    disableColumnMenu: true,
    searchKey: "financeCompany",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.companyName || "N/A"}
        </label>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 170,
    headerName: "Term of loan/years",
    field: "termOfLoan/years",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "termOfLoan/years",
    isDefaultFilterColumn: true,
    fieldKey: "termOfLoan/years",
    formFieldTitle: "Term of loan/years",
    disableColumnMenu: true,
    searchKey: "termOfLoan/years",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#475467" : "#94969C",
          }}
        >
          {`${item?.row?.termOfLoanYears} Years` || "N/A"}
        </label>
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 165,
    headerName: "Down payment %",
    field: "downPayment",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "downPayment",
    isDefaultFilterColumn: true,
    fieldKey: "downPayment",
    formFieldTitle: "Down payment",
    disableColumnMenu: true,
    searchKey: "downPayment",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {`${item?.row?.downPaymentPercentage}%` || "N/A"}
        </label>
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 150,
    headerName: "Intertest rate %",
    field: "intertestRate",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "intertestRate",
    isDefaultFilterColumn: true,
    fieldKey: "intertestRate",
    formFieldTitle: "Intertest rate",
    disableColumnMenu: true,
    searchKey: "intertestRate",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {`${item?.row?.interestRate}%` || "N/A"}
        </label>
      );
    },
  },
  {
    id: 6,
    formFieldId: 6,
    minWidth: 400,
    headerName: "Remarks",
    field: "remarks",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "remarks",
    isDefaultFilterColumn: true,
    fieldKey: "remarks",
    formFieldTitle: "Remarks",
    disableColumnMenu: true,
    searchKey: "remarks",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.remarks || "N/A"}
        </label>
      );
    },
  },
];
